import { initializeApp } from "firebase/app";
import { getPerformance } from "firebase/performance";

export default {
	data() {
		return {
			firebaseApp: null,
			firebasePerfTracker: null,
			firebaseConfig: {
				apiKey: "AIzaSyCx7SQ1rhJzQXnxy-UPstZ9o5WcSH4FRyM",
				authDomain: "workflow-f6851.firebaseapp.com",
				projectId: "workflow-f6851",
				storageBucket: "workflow-f6851.firebasestorage.app",
				messagingSenderId: "818358795586",
				appId: "1:818358795586:web:5d1e7be1f0ef76bc6bdcdb",
				measurementId: "G-73WV2KGC0P",
			},
		};
	},
	computed: {},
	watch: {},
	async created() {
		if (process.env.VUE_APP_ENVIRONMENT === "production") {
			await this.initializeService();
		}
	},
	methods: {
		async initializeService() {
			try {
				this.firebaseApp = await initializeApp(this.firebaseConfig); // If initializeApp is async
				if (this.firebaseApp) {
					this.firebasePerfTracker = await getPerformance(
						this.firebaseApp,
					); // If getPerformance is async
				}
			} catch (error) {
				console.error("Error initializing service:", error);
			}
		},
	},
};
